import { Progress, Spin } from 'antd';

import { TFunction } from 'i18next';
import { AnyObject } from 'yup';

import { ColumnTypes } from '../common/table/type';
import { FileStatusEnum } from '../define-document-upload/define-document-upload.config';

export const getColumnsUpload = (
	t: TFunction<'documentArea' | 'message'>
): ColumnTypes[number][] => [
	{
		title: 'NO.',
		dataIndex: 'no',
		key: 'no',
		width: 50,
		align: 'center',
		render: (value, record, index) => index + 1,
	},
	{
		title: t('file'),
		dataIndex: 'file',
		key: 'file',
		align: 'center',
		render: (value, record: AnyObject) => (
			<div className="relative flex items-center justify-center">
				<span className="pr-[50px] break-all">
					{record?.file?.name || record?.name}
				</span>

				{record.status === FileStatusEnum.CONVERTING && (
					<div className="w-7 h-7 absolute right-0">
						<Spin />
					</div>
				)}
				{![FileStatusEnum.CONVERTING, FileStatusEnum.WAITING].includes(
					record.status
				) && (
					<div className="absolute right-0">
						<Progress
							percent={record.progress}
							type="circle"
							status={record.status === 'error' ? 'exception' : undefined}
							size={28}
							strokeWidth={12}
						/>
					</div>
				)}
			</div>
		),
	},
];
